module.exports = __webpack_public_path__ + "img/calendar2-minus-fill.658b1978.svg";